import { JsonObject, JsonProperty } from 'json2typescript';
import { User } from '../users/user';

@JsonObject('Document')
export class Document {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('ext', String, true)
    ext = null;

    @JsonProperty('uploaded_by', User, true)
    uploadedBy: User = null;

    @JsonProperty('document', String, true)
    document = '';

    @JsonProperty('created_date', String, true)
    createdDate = '';
}

